module.exports = __webpack_public_path__ + "img/error-girl.04326e63.png";